import { render, staticRenderFns } from "./FormRO04_1.vue?vue&type=template&id=22f85f97"
import script from "./FormRO04_1.vue?vue&type=script&lang=js"
export * from "./FormRO04_1.vue?vue&type=script&lang=js"
import style0 from "./FormRO04_1.vue?vue&type=style&index=0&id=22f85f97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports